import L, { TileLayer, LayerGroup } from 'leaflet';
import { nzChartLayerGroup } from './nzCharts';

export type BaseLayerName =
    | 'LINZ Aerial'
    | 'OpenStreetMap'
    | 'NZ Topo'
    | 'ESRI World Imagery'
    | 'NZ Charts';

export type BaseLayers = Record<BaseLayerName, TileLayer | LayerGroup>;

export const linzAttribution = '© <a href="//www.linz.govt.nz/linz-copyright">LINZ CC BY 4.0</a> © <a href="//www.linz.govt.nz/data/linz-data/linz-basemaps/data-attribution">Imagery Basemap contributors</a>';
export const osmAttribution = '© OpenStreetMap contributors';

export function createBaseLayers(): {
    defaultLayer: TileLayer;
    baseLayers: BaseLayers;
} {
    const baseLayers: BaseLayers = {
        'LINZ Aerial': L.tileLayer(
            'https://basemaps.linz.govt.nz/v1/tiles/aerial/WebMercatorQuad/{z}/{x}/{y}.webp?api=c01jhpd42zm405nqbcz9fx71jpq',
            { maxZoom: 24, attribution: linzAttribution}
        ),
        'OpenStreetMap': L.tileLayer(
            'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            { maxZoom: 19, attribution: osmAttribution }
        ),
        'NZ Topo': L.tileLayer(
            'https://tiles-cdn.koordinates.com/services;key=596660e0d02e4dce93c6799002330e1f/tiles/v4/layer=50767/EPSG:3857/{z}/{x}/{y}.png',
            { maxZoom: 18, attribution: linzAttribution }
        ),
        'ESRI World Imagery': L.tileLayer(
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            { maxZoom: 21, attribution: '© Esri, Maxar, Earthstar Geographics' }
        ),
        'NZ Charts': nzChartLayerGroup,
    };

    return {
        defaultLayer: baseLayers['NZ Charts'] as TileLayer,
        baseLayers
    };
}
